import React, { useState, useEffect } from 'react';
import { TextField, Button, Paper, Grid, Typography, Checkbox, FormControlLabel, MenuItem } from '@mui/material';
import { ApiRequest } from '../../services/api';
import { useNavigate } from 'react-router-dom';

function NewIngredient() {
  const [marcas, setMarcas] = useState([]);
  const [ingredientName, setIngredientName] = useState('');
  const [isProduct, setIsProduct] = useState(false);
  const [brand, setBrand] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const response = await ApiRequest("api/Catalogo/ListarMarcas", "GET");
        setMarcas(response);
      } catch (error) {
        console.error("Error al cargar marcas", error);
      }
    };

    fetchMarcas();
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1]; 
        setImageBase64(base64String);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false);

    if (!ingredientName) {
      setError(true);
      return;
    }

    try {
      const response = await ApiRequest('api/Ingrediente/AgregarIngrediente', 'POST', {
        Nombre: ingredientName,
        EsProducto: isProduct, 
        Marca: brand || "", // Si no se selecciona marca, se manda vacío
        Imagen: imageBase64 || "", // Si no se sube imagen, se manda vacío
      });

      if (response) {
        alert('Ingrediente agregado con éxito');
        navigate('/Dashboard/Ingredientes'); 
      } else {
        console.error('Error al agregar el ingrediente');
      }
    } catch (error) {
      console.error('Error al hacer la solicitud:', error);
    }
  };

  return (
    <Paper sx={{ padding: 3, maxWidth: 500, margin: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Agregar Nuevo Ingrediente
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Nombre del Ingrediente"
              variant="outlined"
              fullWidth
              value={ingredientName}
              onChange={(e) => setIngredientName(e.target.value)}
              error={error && !ingredientName}
              helperText={error && !ingredientName ? 'El nombre es obligatorio' : ''}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isProduct}
                  onChange={(e) => setIsProduct(e.target.checked)}
                  color="primary"
                />
              }
              label="¿Es un producto?"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              label="Seleccionar Marca (Opcional)"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              fullWidth
              margin="normal"
            >
              <MenuItem value="">Sin marca</MenuItem>
              {marcas.map((marca) => (
                <MenuItem key={marca.id} value={marca.id}>
                  {marca.nombre}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" component="label" fullWidth>
              Seleccionar Imagen (Opcional)
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
              />
            </Button>
          </Grid>

          {imagePreview && (
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                Vista previa:
              </Typography>
              <img
                src={imagePreview}
                alt="Vista previa"
                style={{ width: '100%', maxHeight: 200, objectFit: 'cover', borderRadius: 8, marginTop: 10 }}
              />
              <Button
                variant="outlined"
                color="secondary"
                sx={{ mt: 1 }}
                onClick={() => {
                  setImageBase64('');
                  setImagePreview('');
                }}
              >
                Eliminar Imagen
              </Button>
            </Grid>
          )}

          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Agregar Ingrediente
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}

export default NewIngredient;
